<template>
  <svg
    :width="width ?? size"
    :height="height ?? size"
    :viewBox="`0 0 ${width ?? size} ${height ?? size}`"
    preserveAspectRatio="xMidYMid meet"
    xmlns="http://www.w3.org/2000/svg">
    <use :href="path"/>
  </svg>
</template>

<script setup lang="ts">
import { computed } from 'vue';

const { size = 24, name, type } = defineProps<{
  name: string;
  size?: string | number;
  width?: string | number;
  height?: string | number;
  type?: 'country';
}>();

const path = computed(() => {
  if (type === 'country') return `/images/sprite_country.svg#${name}`;
  return `/images/sprite.svg#${name}`;
});
</script>
